import { Grid } from '@mui/material';
import { DraftCardVideo } from '../draft-card-video/draft-card-video';
import { DraftCardImage } from '../draft-card-image/draft-card-image';
import { isVideo } from 'components/uploaded-images/helpers';
import { isPostDraftUpload } from '../../utils';
import { TActivityFeedDraftItemUploads } from 'redux-store/api/activity-feed';

interface IDraftCardMediaItem {
  item: TActivityFeedDraftItemUploads[number];
  onMediaViewerOpen: () => void;
  videoThumbnails?: Map<string, string>;
}

export const DraftCardMediaItem = ({ item, onMediaViewerOpen, videoThumbnails }: IDraftCardMediaItem) => {
  const isVideoItem = isVideo(item.mimeType);
  const isDraftUpload = isPostDraftUpload(item);

  const videoSrc = isDraftUpload
    ? (item.options?.previewUrl || videoThumbnails?.get(item.id) || '')
    : '';

  return (
    <Grid onClick={onMediaViewerOpen}>
      {isVideoItem ? (
        <DraftCardVideo
          src={videoSrc}
          alt={item.name}
          duration={isDraftUpload ? item?.options?.duration : ''}
        />
      ) : (
        <DraftCardImage src={item.url} alt={item.name} />
      )}
    </Grid>
  );
};
